import {
  closestCenter,
  DndContext,
  type DragEndEvent,
  type DragOverEvent,
} from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  ProfileModuleType,
  type ProfileModuleDto,
  type ProfileTemplateFieldMode,
} from '@up2stay/up2promo-api-client';
import type { IconList, IconName } from '@up2stay/up2promo-ui';
import {
  Button,
  ConfirmDialog,
  getSocialCustomIconPickerList,
  Icon,
  IconPicker,
  iconPickerI18nDe,
  InlineEditCard,
  Input,
  Label,
  SocialLinkIcon,
} from '@up2stay/up2promo-ui';
import { cn } from '@up2stay/up2promo-ui';
import { ExternalLink, GripVertical, Plus, Trash2 } from 'lucide-react';
import { createElement, useEffect, useMemo, useRef, useState } from 'react';
import type { ModuleEntryGovernanceProps } from '@/core/components/profile/module-entry-governance';
import {
  ModuleEntryListRowBody,
  ModuleEntryOverrideHint,
  ModuleEntryPolicySlot,
} from '@/core/components/profile/module-entry-governance-ui';
import { ProfileFieldLockedHint } from '@/core/components/profile-templates/profile-field-locked-hint';
import { isIndividualFieldMode } from '@/core/components/profile-templates/template-member-value-inputs';
import { useDndProfileSensors } from '@/core/hooks/use-dnd-profile-sensors';
import { useIsMobile } from '@/core/hooks/use-mobile';
import {
  lockBodyScrollDuringDrag,
  triggerDragEndHaptic,
  triggerDragOverHaptic,
  triggerDragStartHaptic,
  unlockBodyScrollAfterDrag,
} from '@/core/lib/dnd-haptics';
import {
  defaultPolicyForNewEntry,
  isEntryPolicyLocked,
  resolveEntryPolicy,
} from '@/core/lib/profile-module-entry-policies';
import { openExternalUrl } from '@/core/lib/open-external-url';
import {
  getSocialHandlePrefix,
  getSocialIcon,
  SOCIAL_ICONS,
  getSocialUrl,
  getSocialUsername,
  parseCustomSocialIconName,
} from '@/core/lib/socials';
import {
  type SocialPlatform,
  type SocialLink,
  type SocialsModuleConfig,
} from '@/core/types/profile-modules';

export function SocialPlatformIcon({
  platform,
  className,
}: {
  platform: SocialPlatform;
  className?: string;
}) {
  return createElement(SOCIAL_ICONS[platform] ?? SOCIAL_ICONS.custom, {
    className,
  });
}
